/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

  const cascadeItems = document.querySelectorAll('[data-cascade-item]');

  // Set initial state for all cascade items: alternate left/right
  cascadeItems.forEach((item, i) => {
    const fromX = i % 2 === 0 ? -80 : 80; // Even: left, Odd: right
    gsap.set(item, { autoAlpha: 0, x: fromX });
    ScrollTrigger.create({
      trigger: item,
      start: "top 60%",
      onEnter: () => {
        gsap.to(item, {
          autoAlpha: 1,
          x: 0,
          duration: 0.8,
          ease: "power2.out"
        });
      },
      markers: false,
    });
  });

  // for p copy class revel, add a scroll trigger to reveal text using SplitText attach % progress of revelation to the scroll tracker so if user scrolls up it revesres the reveal word by word, fade int stagger
  const revealText = document.querySelectorAll('.reveal-text p');
  revealText.forEach((text) => {
    const split = new SplitText(text, { type: "words, chars" });
    gsap.set(split.chars, { autoAlpha: 0, y: 0 });

    // Create the reveal animation as a paused timeline
    const tl = gsap.timeline({ paused: true })
      .to(split.chars, {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        stagger: 0.05
      });

    // Link the timeline's progress to scroll position, but slow down the reveal
    ScrollTrigger.create({
      trigger: text,
      start: "top 80%",
      end: "bottom 40%", // extend the end position for slower reveal
      scrub: 1.5, // add lag to the scrub (higher = more lag)
      animation: tl,
      markers: false,
    });
  });

  // When a top-level nav item with children is clicked:
  document.querySelectorAll('button.sliderow').forEach(item => {
    item.addEventListener('click', function() {
      document.querySelector('.mobile-menu__block--menu-columns').classList.add('is-hidden');
    });
  });

  // When the "Back" button is clicked:
  document.querySelectorAll('button.sliderow__back-button').forEach(backBtn => {
    backBtn.addEventListener('click', function() {
      document.querySelector('.mobile-menu__block--menu-columns').classList.remove('is-hidden');
    });
  });


  function updateColumnsDual(foodSelectId, competitorSelectId, brandClass) {
  var foodSelect = document.getElementById(foodSelectId);
  var competitorSelect = document.getElementById(competitorSelectId);
  if (!foodSelect || !competitorSelect) return;

  function showMatching() {
    var food = foodSelect.value.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
    var against = competitorSelect.value.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
    var items = document.querySelectorAll('.grid-item.' + brandClass);
    items.forEach(function(item) {
      if (
        item.getAttribute('data-food') === food &&
        item.getAttribute('data-against') === against
      ) {
        item.classList.add('show');
        item.classList.remove('hide');
      } else {
        item.classList.remove('show');
        item.classList.add('hide');
      }
    });
  }

  foodSelect.addEventListener('change', showMatching);
  competitorSelect.addEventListener('change', showMatching);

  // Initial show
  showMatching();
}



// For ALU brand
updateColumnsDual('brand-select', 'competitor-select', 'alu-brand');

// For Competitor brand
updateColumnsDual('competitor-select', 'brand-select', 'competitor-brand');



function updateToggleEllipsisHeight() {
  // Do not apply on product pages
  if (
    (document.body && document.body.classList && document.body.classList.contains('template-product')) ||
    document.querySelector('product-component')
  ) {
    return;
  }
  document.querySelectorAll('toggle-ellipsis').forEach(function(el) {
  // Outer-variant has actions outside and uses a different display height
  var hasOuterContent = !!el.querySelector('.toggle-ellipsis-outer__content');
  var hasOuterActions = el.nextElementSibling && el.nextElementSibling.matches('[data-outer-actions]');
  var isOuterVariant = hasOuterContent || hasOuterActions;

  let height = isOuterVariant ? (window.innerWidth >= 750 ? 77 : 67) : (window.innerWidth >= 750 ? 120 : 110);
    el.setAttribute('data-height', height);
    el.style.setProperty('--height', height + 'px');
  // Signal CSS that measurement is complete so clamp can be applied safely
  el.setAttribute('data-ready', 'true');
  });
}

// Run on load and resize
window.addEventListener('DOMContentLoaded', updateToggleEllipsisHeight);
window.addEventListener('resize', updateToggleEllipsisHeight);


  // Sticky header offset for in-page anchors
  function setStickyHeaderOffset() {
    try {
      // Try common header wrappers in Broadcast theme
      var header = document.querySelector('header.theme__header') || document.querySelector('[data-header-wrapper]') || document.querySelector('header.header') || document.querySelector('header');
  var height = header ? header.offsetHeight : 100;
  // Use exact header height for offset
  var offset = Math.max(0, height);
  document.documentElement.style.setProperty('--sticky-header-offset', offset + 'px');
  // Expose height for theme scripts that query [data-header-height]
  if (header) header.setAttribute('data-header-height', String(height));
    } catch (e) {
      // noop
    }
  }
  window.addEventListener('DOMContentLoaded', setStickyHeaderOffset);
  window.addEventListener('resize', setStickyHeaderOffset);

  // Anchor scrolling: account for sticky header height
  function getStickyHeaderOffset() {
  var header = document.querySelector('header.theme__header') || document.querySelector('[data-header-wrapper]') || document.querySelector('header.header') || document.querySelector('header');
  var height = header ? header.offsetHeight : 100;
  // keep CSS var updated too
  document.documentElement.style.setProperty('--sticky-header-offset', height + 'px');
    return height;
  }

  function scrollToAnchorId(id, behavior, retries) {
    var target = document.getElementById(id);
    if (!target) return;
  var offset = getStickyHeaderOffset();
  var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    try {
      // Prefer GSAP ScrollSmoother if present (prevents conflicts with transformed wrappers)
      var smoother = (window.ScrollSmoother && window.ScrollSmoother.get && window.ScrollSmoother.get()) || null;
      if (smoother && typeof smoother.scrollTo === 'function') {
        smoother.scrollTo(Math.max(0, top), behavior !== 'auto');
      } else {
        window.scrollTo({ top: Math.max(0, top), behavior: behavior || 'smooth' });
      }
    } catch (e) {
      window.scrollTo(0, Math.max(0, top));
    }
    // Re-run once or twice after layout settles (sticky header toggle, images load)
    if (retries && retries > 0) {
      setTimeout(function() { scrollToAnchorId(id, 'auto', retries - 1); }, 140);
    }
  }

  // Handle clicks on in-page links
  document.addEventListener('click', function(e) {
    // Support both same-page hashes and full URLs with hashes
    var link = e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    // Only act on anchors
    var url;
    try { url = new URL(href, window.location.href); } catch (_) { return; }
    if (!url.hash) return;
    var id = decodeURIComponent(url.hash.slice(1));
    var target = document.getElementById(id);
    if (!target) return; // let browser handle if target not found
  e.preventDefault();
  // Stop other click handlers (theme a11y/smoothscroll) from also running
  if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    // update URL to full target while avoiding native jump
    if (history && history.pushState) {
      history.pushState(null, '', url.pathname + url.search + '#' + id);
    } else {
      window.location.hash = id;
    }
  scrollToAnchorId(id, 'smooth', 1);
  });

  // Adjust on load if there is a hash
  window.addEventListener('DOMContentLoaded', function() {
    // Disable conflicting polyfill if present
    try {
      if (window.SmoothscrollAnchorPolyfill && typeof window.SmoothscrollAnchorPolyfill.destroy === 'function') {
        window.SmoothscrollAnchorPolyfill.destroy();
      }
    } catch(_) {}
    if (window.location.hash && window.location.hash.length > 1) {
      var id = decodeURIComponent(window.location.hash.slice(1));
      // Defer to ensure layout is stable
  setTimeout(function() { scrollToAnchorId(id, 'auto', 2); }, 0);
    }
  });

  // Adjust on hash change (e.g., back/forward nav)
  window.addEventListener('hashchange', function() {
    if (window.location.hash && window.location.hash.length > 1) {
      var id = decodeURIComponent(window.location.hash.slice(1));
  scrollToAnchorId(id, 'smooth', 1);
    }
  });

  // Observe header size changes (e.g., when sticky state toggles) and update CSS var
  (function observeHeader() {
    var header = document.querySelector('header.theme__header') || document.querySelector('[data-header-wrapper]') || document.querySelector('header.header') || document.querySelector('header');
    if (!header || typeof ResizeObserver === 'undefined') return;
    var ro = new ResizeObserver(function() { setStickyHeaderOffset(); });
    ro.observe(header);
  })();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
